const REQUEST_COVID_REPORTS = '@@covidReport/REQUEST_COVID_REPORTS';
const COVID_REPORTS_RESPONSE = '@@covidReport/COVID_REPORTS_RESPONSE';
const REQUEST_COVID_REPORT_DATE_RANGE = '@@covidReport/REQUEST_COVID_REPORT_DATE_RANGE';
const COVID_REPORT_DATE_RANGE_RESPONSE = '@@covidReport/COVID_REPORT_DATE_RANGE_RESPONSE';

export default {
    REQUEST_COVID_REPORTS,
    COVID_REPORTS_RESPONSE,
    REQUEST_COVID_REPORT_DATE_RANGE,
    COVID_REPORT_DATE_RANGE_RESPONSE,
};
